export default __webpack_public_path__ + "static/media/data-driven-environmental-assessments.af399299.png";